import { addComponent, findComponentList } from "@/api/archi/conponent";
import TnInput from "@/global/components/input/tn-input";
import TnMessage from "@/global/components/message";
import SideTool from "@/global/components/side-tool";
import { Component } from "@/global/interface/archi/component";
import { graphicStore } from "@/global/store/graphic-store";
import { Button } from "antd";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Vector3 } from "three";
import { DragModal } from "tncet-common";
import "./index.less"
import PlaceButton from "@/global/components/place-button";
import { ModelBase, Point } from "pytha";
import { ARCHI_SUB_CONTROL } from "@/passets/archibase-engine/enums/archi-sub-control";

export default function ComponentPanel(second) {

    const [componentList, setComponentList] = useState<Component[]>([])
    const [visible, setVisible] = useState<boolean>(false)
    const [componentName, setComponentName] = useState<string>("")

    const [activeId, setActiveId] = useState<number>(null)

    useEffect(() => {
        findComponentList().then(res => {
            setComponentList([...res?.data])
        })
    }, [])

    const addComponentClick = () => {
        let selectEntities = graphicStore?.extraContext?.getCurrentViewEditor()?.selectControl.getSelectedEntityList()
        if (selectEntities?.length > 0) {
            setVisible(true)
        } else {
            TnMessage.warning("请选择要包装成组件的图元")
        }
    }

    const onSaveComponent = () => {
        setVisible(false)
        let selectEntities = graphicStore?.extraContext?.getCurrentViewEditor()?.selectControl.getSelectedEntityList()
        // 计算当前选中图元的包围盒
        let minX = +Infinity;
        let minY = +Infinity;
        let minZ = +Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        let boundingBoxs = [];
        selectEntities.forEach(item => {
            boundingBoxs.push(item.getBoundingBox());
        })
        for (let i = 0, l = boundingBoxs.length; i < l; i++) {
            minX = Math.min(minX, boundingBoxs[i].min.x);
            minY = Math.min(minY, boundingBoxs[i].min.y);
            minZ = Math.min(minZ, boundingBoxs[i].min.z);
            maxX = Math.max(maxX, boundingBoxs[i].max.x);
            maxY = Math.max(maxY, boundingBoxs[i].max.y);
            maxZ = Math.max(maxZ, boundingBoxs[i].max.z);
        }
        // 基点（组件的插入点），包围盒的最小角点
        let basePoint = new Vector3(minX, minY, minZ);
        // 计算以基点为坐标原点，当前坐标系下，图元的几何信息
        let moveDir = basePoint.clone().negate();
        let componentDefinedEntities = selectEntities.map(entity => entity.clone());
        componentDefinedEntities.forEach(entity => entity.move(moveDir.clone().normalize(), moveDir.length()));
        let entitiesJson = componentDefinedEntities.map(entity => entity.toJson())
        let component: Component = {
            name: componentName,
            entities: entitiesJson,
            position: {
                x: basePoint.x,
                y: basePoint.y,
                z: basePoint.z,
            }
        }

        addComponent(component).then(res => {
            TnMessage.success("添加成功！")
            component.id = res.data
            component.uuid = res.data
            setComponentList([...componentList, component])
        }).catch(() => {
            TnMessage.error("添加失败！")
        })
    }


    const onAssembleComponentClick = (component: Component) => {
        let entities: ModelBase[] = []
        for (let i = 0; i < component.entities.length; i++) {
            let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(component.entities[i].type))();
            entity.fromJson(component.entities[i]);
            entities.push(entity)
        }
        let c_position = component.position || new Point(0, 0, 0)
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.ADDBUILDINGCOMPONENTCONTROL.name);
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.setInitControlData.dispatch(
            {
                entities: entities,
                position: new Point(c_position.x, c_position.y, c_position.z),
            }
        );
    }

    return (
        <div className="component-main">
            <SideTool onAddClick={addComponentClick} />
            <div className="component-list">
                {componentList?.map((item, index) => (
                    <div
                        className={classNames({
                            "item": true,
                            "item-active": activeId == index
                        })}
                        key={index}
                        onClick={() => { setActiveId(index) }}
                    >
                        <div style={{ marginRight: "auto" }}>{item.name}</div>
                        {activeId == index && <PlaceButton onClick={() => { onAssembleComponentClick(item) }} />}
                    </div>
                ))}
            </div>
            <DragModal
                visible={visible}
                title="组件名称"
                onClose={() => { setVisible(false) }}
            >
                <TnInput value={componentName} onTextChange={(e) => { setComponentName(e) }} />
                <Button onClick={() => { onSaveComponent() }}>确认</Button>
            </DragModal>
        </div>
    )
}